module.exports = __webpack_public_path__ + "static/media/circle.f15b04a0.svg";